export default "__VITE_ASSET__BApkrbU$__"